<template>
  <b-form-group>
    <template slot="label">
      <span
        v-back-to-default="[
          $parent.inheritedControlInfo,
          control,
          'customCode',
          $parent.backToDefault
        ]"
      >
        Code:
      </span>
    </template>

    <div class="templateEditor">
      <codemirror
        :value="control.customCode || ''"
        :options="cmOptions"
        @input="onCmCodeChange"
      />
    </div>
  </b-form-group>
</template>

<script>
// helpers
import constants from '@/helpers/constants'

export default {
  props: ['control'],
  data () {
    return {
      cmOptions: constants.cmTemplateOptions,
    }
  },
  methods: {
    onCmCodeChange (value) {
      this.control.customCode = value
    },
  }
}
</script>
